module.exports = __webpack_public_path__ + "static/Noom-7749af9f09660fe21c5064973c1954c0.jpg";